import { lazyLoad } from 'utils/loadable';

export const EntityMaterialCategoryListPage = lazyLoad(
  () => import('./index'),
  module => module.EntityMaterialCategoryListPage
);
